import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Chip,
  Collapse,
  Select,
  MenuItem,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  IconButton,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { useState, useEffect } from "react";
import { get, post } from "../../../../utils/api";
import BulkUploadAdd from "./BulkUploadAdd";
import BulkFileUpload from "../../StationaryCombustion.js/NaturalGas/BulkFileUpload";
import { validateNumber } from "../../../../utils/validateFields";
import { numberError } from "../../../../utils/validationMessage";
const BulkUpload = ({
  matchData,
  onClose,
  onConfirm,
  onAddItem,
  setMatchData,
  bulkUploadTable,
  onOpenAddEquipment,
  bulkuploadInputData,
  url,
  submitUrl,
  jsonBulkUpload = [],
  bulkUploadUrl,
  setsnackOpen,
}) => {
  const [formData, setFormData] = useState({});
  const [expandedRows, setExpandedRows] = useState({});
  const [errors, setErrors] = useState({});
  const [equipmentList, setEquipmentList] = useState([]);
  const [matchedKey, setMatchedKey] = useState(matchData);
  const [findJson, setFinalJson] = useState(jsonBulkUpload);
  
  // Document upload state management
  const [documentUploadConfirmed, setDocumentUploadConfirmed] = useState(false);
  const [documentUploadType, setDocumentUploadType] = useState("none"); // "none", "individual", "same"
  const [commonDocument, setCommonDocument] = useState(null);
  const [individualDocuments, setIndividualDocuments] = useState({});
  const [showNoDocumentDialog, setShowNoDocumentDialog] = useState(false);

  useEffect(() => {
    const fetchEquipmentList = async () => {
      const response = await get(url);
      const names = response.data?.data?.map((item) => item?.vehicleNumber);
      setEquipmentList(names);
    };
    fetchEquipmentList();
  }, [url]);
  useEffect(() => {
    const updated = jsonBulkUpload.map((entry) => {
      const match = matchedKey.find(
        (item) => item.equipment === entry["Vehicle Number"] && item.updatedKey
      );
      return match ? { ...entry, "Vehicle Number": match.updatedKey } : entry;
    });
    // console.log("matchedddddd", matchedKey, jsonBulkUpload);
    // Check change by comparing with original data
    const isChanged = updated.some(
      (entry, i) =>
        entry.equipment !==
        (matchedKey.find(
          (m) => m.equipment === jsonBulkUpload[i]["Vehicle Number"]
        )?.updatedKey || jsonBulkUpload[i]["Vehicle Number"])
    );
    if (isChanged) {
      setFinalJson(updated);
    }
  }, [jsonBulkUpload, matchedKey]);

  if (!matchData || matchData.length === 0) {
    return null;
  }

  const handleFormChange = (index, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        [field]: value,
      },
    }));

    // If "Add New Equipment" is selected, expand the row
    if (field === "selectedEquipment" && value === "add_new") {
      setExpandedRows((prev) => ({
        ...prev,
        [index]: true,
      }));
    }

    // If any other equipment is selected, close the expanded row and clear form fields (but keep selectedEquipment)
    if (field === "selectedEquipment" && value !== "add_new" && value !== "") {
      setExpandedRows((prev) => ({
        ...prev,
        [index]: false,
      }));

      // Clear form fields but keep the selectedEquipment value
      setFormData((prev) => ({
        ...prev,
        [index]: {
          selectedEquipment: value,
        },
      }));
    }
    if (field === "selectedEquipment" && value !== "" && value !== "add_new") {
      setMatchData((prev) =>
        prev.map((item, i) =>
          i === index && !item.matched ? { ...item, updatedKey: value } : item
        )
      );

      // (optional) keep the parallel matchedKey state in sync
      setMatchedKey((prev) =>
        prev.map((item, i) =>
          i === index && !item.matched
            ? { ...item, updatedKey: value, updatedMatch: true }
            : item
        )
      );
    }
  };

  const handleDocumentUploadConfirmation = (confirmed) => {
    setDocumentUploadConfirmed(confirmed);
    
    // Update finalJson with document upload confirmation
    if (findJson && findJson.length > 0) {
      const updated = findJson.map((entry) => ({
        ...entry,
        documentUploadConfirmed: confirmed,
        documentUploadType: confirmed ? "none" : "none",
        "Document": null
      }));
      setFinalJson(updated);
    }
    
    if (!confirmed) {
      // Reset document upload type to "none" if user chooses not to upload
      setDocumentUploadType("none");
    }
  };

  const handleDocumentUploadTypeChange = (event) => {
    setDocumentUploadType(event.target.value);
    
    // Update finalJson with document upload type
    if (findJson && findJson.length > 0) {
      const updated = findJson.map((entry) => ({
        ...entry,
        documentUploadType: event.target.value,
        "Document": null // Clear document when changing type
      }));
      setFinalJson(updated);
    }
    
    setCommonDocument(null);
    setIndividualDocuments({});
  };

  const handleCommonDocumentChange = (files) => {
    setCommonDocument(files);
    
    // Update finalJson with common document for all entries
    if (findJson && findJson.length > 0) {
      const updated = findJson.map((entry) => ({
        ...entry,
        "Document": files
      }));
      setFinalJson(updated);
    }
  };

  const handleIndividualDocumentChange = (index, files) => {
    setIndividualDocuments(prev => ({
      ...prev,
      [index]: files
    }));
    
    // Update finalJson with individual document for specific entry
    if (findJson && findJson.length > 0) {
      const updated = findJson.map((entry, i) => {
        if (i === index) {
          return {
            ...entry,
            "Document": files
          };
        }
        return entry;
      });
      setFinalJson(updated);
    }
  };

  const handleClearCommonDocument = () => {
    setCommonDocument(null);
    
    // Update finalJson to clear common document for all entries
    if (findJson && findJson.length > 0) {
      const updated = findJson.map((entry) => ({
        ...entry,
        "Document": null
      }));
      setFinalJson(updated);
    }
  };

  const handleClearIndividualDocument = (index) => {
    setIndividualDocuments(prev => {
      const newDocs = { ...prev };
      delete newDocs[index];
      return newDocs;
    });
    
    // Update finalJson to clear individual document for specific entry
    if (findJson && findJson.length > 0) {
      const updated = findJson.map((entry, i) => {
        if (i === index) {
          return {
            ...entry,
            "Document": null
          };
        }
        return entry;
      });
      setFinalJson(updated);
    }
  };

  const handleProceedWithoutDocuments = () => {
    setShowNoDocumentDialog(false);
    performUpload();
  };

  const handleCancelProceedWithoutDocuments = () => {
    setShowNoDocumentDialog(false);
  };

  const performUpload = async () => {
    if (!findJson || findJson.length === 0) {
      console.log("No data to upload.");
      return;
    }

    // Prepare data structure with document upload information
    const uploadData = {
      excelData: findJson,
      documentUploadType: documentUploadType,
      commonDocument: commonDocument,
      individualDocuments: individualDocuments,
    };

    console.log("Final upload data structure:", uploadData);

    await post(bulkUploadUrl, uploadData)
      .then((res) => {
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        onConfirm();
        onClose();
      })
      .catch((err) => {
        const errMessage = err.response?.data?.details
          ?.map((el) => el?.error)
          ?.join(",");
        if (err?.response?.status === 422) {
        }
        setsnackOpen({
          open: true,
          message: errMessage ?? err.response?.data?.message ?? "Network Error",
          severity: "error",
        });
      });
  };

  const handleSubmit = async () => {
    // Check if user wants to upload documents but hasn't uploaded any
    const needsDocs = documentUploadConfirmed && documentUploadType !== "none";
    
    if (needsDocs) {
      const hasCommonDoc = documentUploadType === "same" && commonDocument && commonDocument.length > 0;
      const hasIndividualDocs = documentUploadType === "individual" && 
        Object.keys(individualDocuments).length > 0 &&
        Object.values(individualDocuments).some(docs => docs && docs.length > 0);
      
      if (!hasCommonDoc && !hasIndividualDocs) {
        setShowNoDocumentDialog(true);
        return;
      }
    }
    
    // If no dialog is needed, proceed with upload
    await performUpload();
  };

  const allMatched = matchData.every((item) => item.matched);

  const allUnmatchedSelected = matchData
    .map((item, idx) => ({ item, idx }))
    .filter(({ item }) => !item.matched)
    .every(({ idx }) => {
      const selected = formData[idx]?.selectedEquipment;
      // Must be non-empty and not "Tap to Select"
      return selected && selected !== "";
    });

  const confirmButtonEnabled =
    allMatched ||
    (matchData.some((item) => !item.matched) && allUnmatchedSelected);

  const validateForm = (index) => {
    const data = formData[index] || {};
    const newErrors = {};

    console.log("DEBUG - validateForm called with index:", index, "data:", data);

    // Validate required vehicle fields
    if (!data.transportType?.trim()) {
      newErrors.transportType = "Transport type is required";
    }
    if (data?.transportType === "Passenger" && !data.ownership?.trim()) {
      newErrors.ownership = "Ownership is required";
    }
    if (data.logisticsVendor==="" && data?.ownership === "Leased") {
      newErrors.logisticsVendor = "Logistics vendor is required";
    }
   
    if (!data.vehicleCategory?.trim() && data?.transportType === "Freight") {
      newErrors.vehicleCategory = "Vehicle category is required";
    }
    if (!data.vehicleType?.trim()) {
      newErrors.vehicleType = "Vehicle type is required";
    }
    if (!data.fuelType?.trim()) {
      newErrors.fuelType = "Fuel type is required";
    }
    if (!data.brand?.trim()) {
      newErrors.brand = "Brand is required";
    }
    if (!data.model?.trim()) {
      newErrors.model = "Model is required";
    }
    if (!data.purchaseDate?.trim()) {
      newErrors.purchaseDate = "Purchase date is required";
    }
    if (!data.lastServiceDate?.trim()) {
      newErrors.lastServiceDate = "Last service date is required";
    }
    if(!data?.bharatStageEmissionType?.trim()) {
      newErrors.bharatStageEmissionType = "Bharat stage emission type is required";
    }
    // Validate declaredEfficiency field
    if (!data.declaredEfficiency?.value || data.declaredEfficiency?.value <= 0) {
      newErrors.declaredEfficiency = {
        ...newErrors.declaredEfficiency,
        value: "Value is required"
      };
    }
    if (!data.declaredEfficiency?.unit?.trim()) {
      newErrors.declaredEfficiency = {
        ...newErrors.declaredEfficiency,
        unit: "Unit is required"
      };
    }

     if (data.transportType === "Passenger") {
        if (!data.ownership) {
          newErrors.ownership = "Ownership is required.";
        }
        if (
          !data.passengerCapacity &&
          !validateNumber(data.passengerCapacity)
        ) {
          newErrors.passengerCapacity = numberError;
        }
      } else if (formData.transportType === "Freight") {
        if (!data.loadCapacity) {
          newErrors.loadCapacity = "Load capacity is required";
        }

        if (
          data.loadCapacity==="" &&
          !validateNumber(data.loadCapacity)
        ) {
          newErrors.loadCapacity = numberError;
        }
      }

      if (data.vehicleNumber==="" && !data.vehicleNumber) {
        const regex = new RegExp(`^${data.vehicleNumber}$`, "i"); // 'i' flag makes it case-insensitive
        const vehicle = equipmentList.filter((el) => regex.test(el.vehicleNumber));

        // Check if the GST Number already exists and the IDs don't match (or if no GST record exists, skip the validation)
        if (
          vehicle.length > 0 &&
          (data ? data?._id !== vehicle[0]?._id : true)
        ) {
          newErrors.vehicleNumber = "Vehicle Number already exists";
        }
      }

    console.log("DEBUG - newErrors:", newErrors);

    setErrors((prev) => ({
      ...prev,
      [index]: newErrors,
    }));

    const isValid = Object.keys(newErrors).length === 0;
    console.log("DEBUG - isValid:", isValid);
    return isValid;
  };
  
  return (
    <>
    <Dialog
      open={bulkUploadTable}
      onClose={onClose}
      maxWidth="lg"
      sx={{
        "& .MuiDialog-paper": {
          width: "60%",
          margin: "16px",
          maxHeight: "calc(100% - 32px)",
          zIndex: 1000,
        },
      }}
    >
      <DialogTitle>Review Bulk Upload Data</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Review the matched and unmatched equipment data. Add unmatched items
          individually.
        </Typography>

        <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
          <Table stickyHeader>
          <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      width: "30%",
                    }}
                  >
                    Data Entered
                  </TableCell>
                 
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      width: "20%",
                    }}
                  >
                    Master Data
                  </TableCell>
                </TableRow>
              </TableHead> <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", width: "40%" }}>
                  Vehicle Number
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", width: "40%" }}>
                  Vehicle Number
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", width: "20%" }}>
                  Action
                </TableCell>
                {documentUploadConfirmed && documentUploadType === "individual" && (
                  <TableCell sx={{ fontWeight: "bold", width: "15%" }}>
                    Document
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {matchData.map((item, index) => (
                <>
                  <TableRow key={index}>
                    <TableCell>{item.equipment}</TableCell>
                    <TableCell>
                      {item.matched ? (
                        <Chip label="Matched" color="success" size="small" />
                      ) : (
                        <FormControl
                          size="small"
                          sx={{ minWidth: 120, width: "80%" }}
                        >
                          <Select
                            value={formData[index]?.selectedEquipment || ""}
                            onChange={(e) =>
                              handleFormChange(
                                index,
                                "selectedEquipment",
                                e.target.value
                              )
                            }
                            fullWidth
                            displayEmpty
                            disabled={item.matched}
                          >
                            <MenuItem value="">Tap to Select</MenuItem>
                            <MenuItem value="add_new">
                              Add New Vehicle +
                            </MenuItem>
                            {equipmentList &&
                              equipmentList.map((item, index) => {
                                return <MenuItem value={item}>{item}</MenuItem>;
                              })}
                          </Select>
                        </FormControl>
                      )}
                    </TableCell>
                    <TableCell>
                      {!item.matched &&
                        (formData[index]?.selectedEquipment === "add_new" ||
                        expandedRows[index] ? (
                          <Button
                            variant="contained"
                            size="small"
                            onClick={() => {
                              setExpandedRows((prev) => ({
                                ...prev,
                                [index]: !prev[index],
                              }));
                            }}
                            sx={{ minWidth: "80px" }}
                          >
                            {expandedRows[index] ? "Close" : "Open"}
                          </Button>
                        ) : null)}
                    </TableCell>
                    {documentUploadConfirmed && documentUploadType === "individual" && (
                      <TableCell>
                        <BulkFileUpload
                          filesList={individualDocuments[index] || []}
                          handleChange={handleIndividualDocumentChange}
                          handleClear={handleClearIndividualDocument}
                          index={index}
                        />
                      </TableCell>
                    )}
                  </TableRow>
                  {/* Expandable form row */}
                  <TableRow>
                    <TableCell
                      style={{ paddingBottom: 0, paddingTop: 0 }}
                      colSpan={documentUploadConfirmed && documentUploadType === "individual" ? 4 : 3}
                    >
                      <Collapse
                        in={expandedRows[index]}
                        timeout="auto"
                        unmountOnExit
                      >
                        <BulkUploadAdd
                          index={index}
                          formData={formData}
                          errors={errors}
                          setErrors={setErrors}
                          validateForm={validateForm}
                          setFormData={setFormData}
                          setMatchData={setMatchData}
                          setExpandedRows={setExpandedRows}
                          bulkuploadInputData={bulkuploadInputData}
                          equipment={item.equipment}
                          url={url}
                          equipmentList={equipmentList}
                          matchData={matchData}
                          submitUrl={submitUrl}
                          setsnackOpen={setsnackOpen}
                        />
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Document Upload Section */}
        <Box sx={{ mt: 3, p: 2, border: "1px solid #e0e0e0", borderRadius: 1 }}>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
            Document Upload
          </Typography>
          <Box>
            <FormControl component="fieldset">
              <FormLabel component="legend">Do you want to upload document?</FormLabel>
              <RadioGroup
                value={documentUploadConfirmed ? "yes" : "no"}
                onChange={(e) => handleDocumentUploadConfirmation(e.target.value === "yes")}
                row
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Box>
          {documentUploadConfirmed && (
            <FormControl component="fieldset" sx={{ mb: 2, mt: 2 }}>
              <FormLabel component="legend">Document Upload Type</FormLabel>
              <RadioGroup
                value={documentUploadType}
                onChange={handleDocumentUploadTypeChange}
                row
              >
                <FormControlLabel value="same" control={<Radio />} label="Same File for All Records" />
                <FormControlLabel value="individual" control={<Radio />} label="Individual File for Each Record" />
              </RadioGroup>
            </FormControl>
          )}

          {documentUploadConfirmed && documentUploadType === "same" && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Upload a single document that will be associated with all records:
              </Typography>
              <BulkFileUpload
                filesList={commonDocument || []}
                handleChange={handleCommonDocumentChange}
                handleClear={handleClearCommonDocument} 
              />
            </Box>
          )}

          {documentUploadConfirmed && documentUploadType === "individual" && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Upload individual documents for each record. Documents will be added as a new column in the table above.
              </Typography>
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ padding: "1rem" }}>
        <Button
          onClick={onClose}
          variant="outlined"
          color="primary"
          sx={{ marginRight: "1rem" }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={!confirmButtonEnabled}
        >
          Confirm Upload
        </Button>
      </DialogActions>
    </Dialog>

    {/* Confirmation Dialog for Proceeding Without Documents */}
    <Dialog
      open={showNoDocumentDialog}
      onClose={handleCancelProceedWithoutDocuments}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6">No Documents Uploaded</Typography>
          <IconButton
            onClick={handleCancelProceedWithoutDocuments}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          You have selected to upload documents but haven't uploaded any files.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Do you want to proceed without uploading documents?
        </Typography>
        <Typography variant="body2" color="text.secondary">
          You can still upload documents later if needed.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ padding: "1rem" }}>
        <Button
          onClick={handleCancelProceedWithoutDocuments}
          variant="outlined"
          color="primary"
          sx={{ marginRight: "1rem" }}
        >
          Upload Documents
        </Button>
        <Button
          onClick={handleProceedWithoutDocuments}
          variant="contained"
          color="primary"
        >
          Proceed Without Documents
        </Button>
      </DialogActions>
    </Dialog>
    </>
  );
};

export default BulkUpload;
